import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
export default class ReplyTemplateModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "discussion", void 0);
    _defineProperty(this, "replyTemplate", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.discussion = this.attrs.discussion;
    this.replyTemplate = Stream(this.discussion.replyTemplate());
  }
  className() {
    return 'ReplyTemplateModal Modal';
  }
  title() {
    return app.translator.trans('fof-discussion-templates.forum.reply_template.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m("textarea", {
      className: "FormControl",
      bidi: this.replyTemplate,
      rows: "6"
    })), m("div", {
      className: "Form-group"
    }, Button.component({
      className: 'Button Button--primary Button--block',
      type: 'submit',
      loading: this.loading
    }, app.translator.trans('fof-discussion-templates.forum.reply_template.submit_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    const replyTemplate = this.replyTemplate();
    if (replyTemplate !== this.discussion.replyTemplate()) {
      this.discussion.save({
        replyTemplate
      }).then(() => {
        m.redraw();
        this.hide();
      }).catch(() => {
        this.loading = false;
        m.redraw();
      });
    } else {
      this.hide();
    }
  }
}
flarum.reg.add('fof-discussion-templates', 'forum/components/ReplyTemplateModal', ReplyTemplateModal);